import { ResponseErrorType } from '@/types/sharedTypes';
import { useField } from 'formik';
import { getFieldError } from '@/helpers/formHelpers/formHelpers';
import { Checkbox, CheckboxProps } from '@/components/form/fields/Checkbox/Checkbox';

type FormikCheckboxType = CheckboxProps & {
  name: string;
  apiError?: ResponseErrorType;
};

export const FormikCheckbox = ({ name, apiError, ...rest }: FormikCheckboxType) => {
  const [field, meta, { setValue }] = useField(name);
  const { apiError: apiErrorMessage, error } = getFieldError(name, meta, apiError);

  const onChangeHandler = () => {
    setValue(!field.value);
  };

  return <Checkbox {...field} onChange={onChangeHandler} apiError={apiErrorMessage} error={error} {...rest} />;
};
